export const DEFAULT_CLOSE_ANIMATION_DURATION = 300; // ms
